export enum Country {
    Norway = 1,
    Sweden = 2,
    Finland = 5
}
